<template>
  <div style="position: relative">
    <img
      src="../assets/return.png"
      alt=""
      class="return"
      @click="$router.push('/rSuccess')"
    />
    <div class="pavilion" v-if="id == 2">
      <div class="image">
        <img src="../assets/bg2.png" alt="" width="100%" />
      </div>
      <div class="content">
        <div class="bigtitle">展馆现状</div>
        <div class="title">Current situation</div>
        <div>
          <p>
            2010年完成世界气象组织与中国气象局联合参展的世界气象馆的筹建工作。世界气象馆是世博会159年历史上气象主题首次独立参展，获得了“上海世博会评委会特别奖”。
          </p>
        </div>
      </div>
    </div>
    <div class="pavilion" v-if="id == 1">
      <div class="image">
        <img src="../assets/bg1.png" alt="" width="100%" />
      </div>
      <div class="content">
        <div class="bigtitle">展馆历史</div>
        <div class="title">History of the Pavilion</div>
        <div>
          <p>
            从1872年开建至今的100多年里，从未间断过对上海气象观测的记录，这里的每个细节都镌刻着岁月的痕迹、见证了上海近现代气象科学的漫长历程。
          </p>
          <p>
            1872年12月1日，徐家汇观象台开始了连续140年的气象观测，标志着徐家汇观象台正式成立。
          </p>
          <p>1879年首次较准确地做出台风预报，揭开了上海天气预报的序幕。</p>
          <p>1884年外滩信号台建成，为海上航行提供气象信号服务。</p>
          <p>1900年徐家汇观象台新楼落成，佘山天文台落成。</p>
          <p>
            1915年7月27-28日，上海遭遇严重的台风侵袭，同年8月10日申报首先刊登徐家汇观象台天气预报，开始对公众提供天气预报服务。
          </p>
          <p>1926年徐家汇观象台参与国际经度联调。</p>
          <p>
            1941年由于太平洋战争爆发，暂停了公众气象服务，但气象观测仍在继续。
          </p>
          <p>
            1949年5月31日，军事管制委员会接管了当时设在大西路（今延安西路）的上海气象台和外滩信号台。
          </p>
          <p>
            1950年12月11日，徐家汇观象台及佘山天文台的气象部分由军委会气象局接管，天文部分由中国科学院紫金山天文台接管。
          </p>
          <p>
            1959年利用马可尼测雨雷达，上海建成中国第一个天气雷达站。经上海市人民委员会报请国务院批准，上海市气象局正式宣告成立，统一领导上海市气象台站。
          </p>
          <p>
            1964年正式开展数值天气预报方法的研究和应用，成为全国最早开展业务数值天气预报的地区之一。
          </p>
          <p>
            1988年上海成立全国最早的区域气象中心，成为上海区域气象通信枢纽。
          </p>
        </div>
      </div>
    </div>
    <div class="pavilion" v-if="id == 3">
      <div class="image">
        <img src="../assets/bg3.png" alt="" width="100%" />
      </div>
      <div class="content">
        <div class="bigtitle">展馆交通</div>
        <div class="title">Exhibition hall traffic</div>
        <img src="../assets/map.png" alt="" width="100%" />
        <div class="item">
          <div class="item-title">详细地址:</div>
          <div class="item-content">徐汇区蒲西路166号</div>
        </div>
        <div class="item">
          <div class="item-title">交通详情:</div>
          <div class="item-content">
            <p>1、可乘坐地铁或公交车；</p>
            <p>
              2、乘坐地铁1、9、11号线至（徐家汇站），从八号口（漕溪北路浦西路）出站。
            </p>
            <p>
              3、可乘公交42、43、44、50、167、171、198、303、320、548、712、732、816、824、830、836、855路等至（徐家汇站），乘205、920路至（南丹路漕溪北路）站。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: "",
    };
  },
  created() {
    this.id = this.$route.params.id;
  },
};
</script>
<style scoped lang="less">
.return {
  position: absolute;
  left: 0.1rem;
  top: 0.2rem;
  z-index: 100;
  width: 0.2rem;
  height: 0.2rem;
}
.pavilion {
  width: 100%;
  position: relative;
  .image {
    width: 100%;
  }
  .content {
    position: relative;
    top: -0.2rem;
    background-color: #fff;
    border-top-left-radius: 0.15rem;
    border-top-right-radius: 0.15rem;
    padding: 0.2rem;
    box-sizing: border-box;
    p {
      margin-bottom: 0.1rem;
      color: #424242;
      line-height: 0.25rem;
      text-align:justify;
    }
    .bigtitle {
      font-size: 0.24rem;
      font-weight: 700;
    }
    .title {
      font-size: 0.15rem;
      margin-bottom: 0.3rem;
    }
    .item {
      display: flex;
      margin-top: 0.24rem;
      .item-title {
        width: 20%;
        font-size: 0.14rem;
      }
      .item-content {
        width: 80%;
        font-size: 0.14rem;
        color: rgb(151, 144, 144);
        padding-left: 0.2rem;
        box-sizing: border-box;
      }
      p {
        color: rgb(151, 144, 144);
        line-height: 0.2rem;
        margin-bottom: 0.1rem;
        text-align:justify;
      }
    }
  }
}
</style>